import { render, staticRenderFns } from "./WhatsAppClient.vue?vue&type=template&id=a53735f4&scoped=true"
import script from "./WhatsAppClient.vue?vue&type=script&lang=js"
export * from "./WhatsAppClient.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppClient.vue?vue&type=style&index=0&id=a53735f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53735f4",
  null
  
)

export default component.exports